import Vue from 'vue'
import {USER_INFO, ACCESS_TOKEN} from '../store/mutation-types'
import { wechatShare } from '@/api/wxshare.js'
import { updateQueryParam } from '@/utils/util'
import wx from 'weixin-js-sdk'

function getSignUrl () {
  var signLink = ''
  var ua = navigator.userAgent.toLowerCase()
  if (/iphone|ipad|ipod/.test(ua)) {
    signLink = window.entryUrl
    if (!signLink) signLink = location.href
  } else {
    signLink = location.href
  }
  return signLink
  // return window.location.href
}

function shareNewApi (params) {
  var data = {// 请求参数
    url: getSignUrl().split('#')[0],
  }
  const userInfo = Vue.ls.get(USER_INFO) ? Vue.ls.get(USER_INFO) : {}
  let appUrl = ''
  let timeLineUrl = ''
  if (window.location.href.indexOf('sourceShare') > 0) {
    params.link = updateQueryParam(params.link, 'userId', userInfo.id)
    params.link = updateQueryParam(params.link, 'mainId', window.sessionStorage.getItem('mainId'))
    params.link = updateQueryParam(params.link, 'sharetimes', new Date().getTime())
    appUrl = updateQueryParam(params.link, 'sourceShare', '1')
    params.linkTimeLine = updateQueryParam(params.linkTimeLine, 'userId', userInfo.id)
    params.linkTimeLine = updateQueryParam(params.linkTimeLine, 'mainId', window.sessionStorage.getItem('mainId'))
    params.linkTimeLine = updateQueryParam(params.linkTimeLine, 'sharetimes', new Date().getTime())
    timeLineUrl = updateQueryParam(params.linkTimeLine, 'sourceShare', '2')
  } else {
    console.log(window.sessionStorage.getItem('mainId'))
    let paramsUrl = `userId=${userInfo.id}&mainId=${window.sessionStorage.getItem('mainId')}&sharetimes=${new Date().getTime()}`
    appUrl = params.link.indexOf('?') > 0 ? `${params.link}&${paramsUrl}&sourceShare=1` : `${params.link}?${paramsUrl}&sourceShare=1`
    timeLineUrl = params.linkTimeLine.indexOf('?') > 0 ? `${params.linkTimeLine}&${paramsUrl}&sourceShare=2` : `${params.linkTimeLine}?${paramsUrl}&sourceShare=2`
  }
  appUrl = updateQueryParam(appUrl, 'entrance', '20')
  timeLineUrl = updateQueryParam(timeLineUrl, 'entrance', '21')
  const token = Vue.ls.get(ACCESS_TOKEN) ? Vue.ls.get(ACCESS_TOKEN) : {}
  fetch(`${process.env.baseURL}/api/wechat/share/config`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .then(data => {
      let appId = data.data.appId
      let timestamp = data.data.timestamp
      let nonceStr = data.data.nonceStr
      let signature = data.data.signature
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId, // 必填，公众号的唯一标识，填自己的！
        timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
        nonceStr, // 必填，生成签名的随机串
        signature, // 必填，签名，见附录1
        jsApiList: [
          'updateAppMessageShareData',
          'updateTimelineShareData',
          'scanQRCode',
          'closeWindow',
        ],
        openTagList: [
          'wx-open-launch-weapp'
        ]
      })
      // wx.error(function (res) {
      //   alert('出错了：' + res.errMsg)// 这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
      // })
      wx.ready(function () {
        // wx.hideMenuItems({
        //   menuList: ['menuItem:copyUrl'] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
        // })
        setTimeout(() => {
          wx.updateAppMessageShareData({
            title: params.title,
            desc: params.desc,
            link: appUrl,
            imgUrl: params.images,
            type: 'link',
            // dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              console.log('分享配置成功新API-朋友')
            },
            cancel: function () {
              console.log('分享配置失败新API-朋友')
            },
            complete: function () {
              console.log('分享完成')
            }
          })
          // 分享给朋友
          wx.updateTimelineShareData({
            title: params.titleTimeLine, // 分享标题
            link: timeLineUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: params.images, // 分享图标
            success: function () {
              console.log('分享配置成功新API-朋友圈')
              // 设置成功
            },
            cancel: function () {
              console.log('分享配置失败新API-朋友圈')
            }
          })
          // 分享到朋友圈
        }, 100)
      })
    })
  // wechatShare(data)// 这里我写了一个公用的接口请求js，这里正常axios请求就可以，只要拿到数据都可以
  //   .then(res => {
  //     // 拿到后端给的这些数据
  //     let appId = res.data.appId
  //     let timestamp = res.data.timestamp
  //     let nonceStr = res.data.nonceStr
  //     let signature = res.data.signature
  //     wx.config({
  //       debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
  //       appId, // 必填，公众号的唯一标识，填自己的！
  //       timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
  //       nonceStr, // 必填，生成签名的随机串
  //       signature, // 必填，签名，见附录1
  //       jsApiList: [
  //         'updateAppMessageShareData',
  //         'updateTimelineShareData',
  //         'scanQRCode',
  //         'closeWindow'
  //       ]
  //     })
  //     // wx.error(function (res) {
  //     //   alert('出错了：' + res.errMsg)// 这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
  //     // })
  //     wx.ready(function () {
  //       // wx.hideMenuItems({
  //       //   menuList: ['menuItem:copyUrl'] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
  //       // })
  //       setTimeout(() => {
  //         wx.updateAppMessageShareData({
  //           title: params.title,
  //           desc: params.desc,
  //           link: appUrl,
  //           imgUrl: params.images,
  //           type: 'link',
  //           // dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
  //           success: function () {
  //             console.log('分享配置成功新API-朋友')
  //           },
  //           cancel: function () {
  //             console.log('分享配置失败新API-朋友')
  //           },
  //           complete: function () {
  //             console.log('分享完成')
  //           }
  //         })
  //         // 分享给朋友
  //         wx.updateTimelineShareData({
  //           title: params.titleTimeLine, // 分享标题
  //           link: timeLineUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  //           imgUrl: params.images, // 分享图标
  //           success: function () {
  //             console.log('分享配置成功新API-朋友圈')
  //             // 设置成功
  //           },
  //           cancel: function () {
  //             console.log('分享配置失败新API-朋友圈')
  //           }
  //         })
  //         // 分享到朋友圈
  //       }, 100)
  //     })
  //   })
}

export function getShareInfo (params) { // 如果分享的内容会根据情况变化，那么这里可以传入分享标题及url
  if (!params) { return }
  // 平台、设备和操作系统
  var system = {
    win: false,
    mac: false,
    x11: false,
    ipad: false
  }
  // 检测平台
  var p = navigator.platform
  system.win = p.indexOf('Win') > -1
  shareNewApi(params)
  // if (system.win) {
  //   shareOldApi(params)
  // } else {
  //   shareNewApi(params)
  // }
}

export function wxConfig (to, system) {
  let curHref = `${process.env.baseURL}${process.env.BASE_URL}${to.fullPath}`
  var data = {// 请求参数
    url: curHref,
  }
  wechatShare(data)// 这里我写了一个公用的接口请求js，这里正常axios请求就可以，只要拿到数据都可以
    .then(res => {
      // 拿到后端给的这些数据
      let appId = res.data.appId
      let timestamp = res.data.timestamp
      let nonceStr = res.data.nonceStr
      let signature = res.data.signature
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId, // 必填，公众号的唯一标识，填自己的！
        timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
        nonceStr, // 必填，生成签名的随机串
        signature, // 必填，签名，见附录1
        jsApiList: [
          'scanQRCode',
          'closeWindow'
        ]
      })
      wx.error(function (res) {
        alert('出错了：' + res.errMsg)// 这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
      })
    })
}
export default {
  getShareInfo
}



// WEBPACK FOOTER //
// ./src/utils/wxShare.js